import Keyframes from '@ff/ui/Keyframes';
import React from 'react';

export default function Animate(props) {
  const { animate, children, ...rest } = props;

  if (!animate) {
    return (
      <React.Fragment>
        {children}
      </React.Fragment>
    )
  }
  return (
    <Keyframes {...rest}>
      {children}
    </Keyframes>
  );
}
